import {
  _primaryControls,
  _increment,
  orderNumber,
  orderDate,
  status,
  paymentType,
  customerName,
  area,
  address,
  totalWeight,
  deliveryFee,
  remarks,
  lastUpdatedBy,
  updatedAt,
  sortable,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    orderNumber,
    orderDate,
    status,
    paymentType,
    customerName,
    area,
    address,
    totalWeight,
    'packages.length': {
      name: 'จำนวนรายการ',
      width: '1fr',
      class: 'text-center',
    },
    deliveryFee,
    remarks,
    lastUpdatedBy,
    updatedAt,
  },
  sortable,
};
